import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import { AccordionDetails } from '@mui/material'

// Root container for AccordionDetails
export const AccordionDetailsRoot = styled(AccordionDetails)({
  padding: '0px',
  display: 'flex',
  flexDirection: 'column',
})

// Content inside AccordionDetails
export const AccordionDetailsContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid #e0e0e0',
  padding: '0px 32px',
  minHeight: '48px',
})

// Styled checkbox
export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.primary.main,
}))
